import React from "react";
import {connect} from "react-redux";
import TextEditor from "./blockLoop/TextEditor"
import FullWidthImage from "./blockLoop/FullWidthImage";
import Introduction from "./blockLoop/Introduction";
import Accordian from "./blockLoop/Accordian";
import Video from "./Video";
import VideoGallery from "./blockLoop/VideoGallery";

class BlockLoop extends React.Component {

    render() {

        return (
          <div className="rob-blockloop">
              {this.props.blockLoop.map(function (name, index) {

                  switch(name.type){
                      case 'textEditor':
                          return  <TextEditor key={index} {...name}/>;
                      case 'fullWidthImage':
                          return  <FullWidthImage key={index} {...name} />;
                      case 'introduction':
                          return  <Introduction key={index} {...name} />;
                      case 'video':
                          return  <Video key={index} {...name} />;
                      case 'videoGallery':
                          return  <VideoGallery key={index} {...name} />;
                      case 'accordian':
                          return  <Accordian key={index} {...name} />;
                      default:
                          return  <div key={index}></div>;
                  }

              })
              }
          </div>
        )
    }
}
BlockLoop.defaultProps = {blockLoop: []};


function mapStateToProps(state) {
    return {
        blockLoop: state.page.blockLoop,
    };
}

export default connect(mapStateToProps)(BlockLoop);




// WEBPACK FOOTER //
// ./src/components/elements/RegionLoop.js